import { AuthActions } from './action-creators';
import { Reducer } from 'redux';
import { actionTypes } from './action-types';

export interface AuthStore {
  isLogin: boolean;
  needLogoutFlags: {
    isLogout: boolean;
    isMoveToRoot: boolean;
  };
  isNewPasswordRequired: boolean;
  isForgetPassword: boolean;
}

const initialState: AuthStore = {
  isLogin: false,
  needLogoutFlags: {
    isLogout: false,
    isMoveToRoot: false,
  },
  isForgetPassword: false,
  isNewPasswordRequired: false,
};

export const authReducer: Reducer<AuthStore, AuthActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        isLogin: true,
        needLogoutFlags: {
          isLogout: false,
          isMoveToRoot: false,
        },
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        isLogin: false,
        needLogoutFlags: {
          isLogout: true,
          isMoveToRoot: action.payload,
        },
      };
    case actionTypes.NEW_PASSWORD_REQUIRED: {
      return {
        ...state,
        isNewPasswordRequired: action.payload,
      };
    }
    case actionTypes.FORGET_PASSWORD:
      return {
        ...state,
        isForgetPassword: action.payload,
      };
    default:
      return state;
  }
};
